export default __webpack_public_path__ + "static/media/context.fc77e9d5.png";